import React, { forwardRef, useState } from 'react'
import CheckInWidget from './CheckInWidget'
import DetailsOnEmotions from './DetailsOnEmotions'
import DayFilteringWidget from './DayFilteringWidget'
import ReasonsForEmotionsWidget from './ReasonsForEmotionsWidget'
import AlertsWidget from './AlertsWidget'
import AssignedActionWidget from './AssignedActionWidget'
import ParticipationWidget from './ParticipationWidget'
import StudentWellbeingComparisonWidget from './StudentWellbeingComparisonWidget'
import StudentPulseHistory from './StudentPulseHistory'
import { daysFilterList } from '../class/ClassAnalyticsWidgets'
import AnalyticsWidgetEvents from '../../../analytics/AnalyticsWidgetEvents'

const AnalyticsWidgets = forwardRef(({ student, subjectId, selectedOptions, daysFilter, setDaysFilter, selectedClass }, ref) => {
    return (
        <div className="flex-1 overflow-x-hidden px-2 pt-[20px] " ref={ref}>
            <AnalyticsWidgetEvents
                subjectId={subjectId || student?.id}
                widgets={[
                    { key: 'check-in', label: 'Check-in' },
                    { key: 'wellbeing-comparison', label: 'Wellbeing comparison' },
                    { key: 'emotion-details', label: 'Emotion details' },
                    { key: 'emotion-reasons', label: 'Reasons for emotions' },
                    { key: 'pulse-history', label: 'Pulse history' },
                    { key: 'alerts', label: 'Alerts' },
                    { key: 'assigned-actions', label: 'Assigned actions' },
                    { key: 'participation', label: 'Participation' },
                ]}
            />
            <DayFilteringWidget daysFilter={daysFilter} daysFilterList={daysFilterList} setDaysFilter={setDaysFilter} />
            <div className="w-full h-[1px] bg-white mt-4"></div>
            <CheckInWidget daysFilter={daysFilter} student={student} analyticsType="student" selectedClass={selectedClass} />
            <StudentWellbeingComparisonWidget daysFilter={daysFilter} student={student} selectedClass={selectedClass} isStudentAnalytics />
            <DetailsOnEmotions daysFilter={daysFilter} student={student} analyticsType="student" />
            <ReasonsForEmotionsWidget daysFilter={daysFilter} student={student} analyticsType="student" />
            <StudentPulseHistory daysFilter={daysFilter} />
            <AlertsWidget daysFilter={daysFilter} student={student} />
            <AssignedActionWidget daysFilter={daysFilter} student={student} />
            <ParticipationWidget daysFilter={daysFilter} student={student} />
        </div>
    )
})

export default AnalyticsWidgets
